import { useContext, type JSX } from 'react';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Header from '@/components/header/Header';
import StripeElementsProvider from '@/components/purchase/StripeElementsProvider';
import AccountScreen from '@/components/subscribe/AccountScreen';
import PaymentFormScreen from '@/components/subscribe/PaymentFormScreen';
import { SubscribeContext } from '@/components/subscribe/SubscribeContextProvider';
import GridWrapper from '@/components/ui/GridWrapper';
import { usePurchaseParamsState } from '@/hooks/store';

import { Wrapper } from './styles';

const SubscribeScreens = () => {
	const { activeComponentName } = useContext(SubscribeContext);
	const { coupon } = usePurchaseParamsState();

	const screenComponents: Record<string, JSX.Element> = {
		AccountScreen: <AccountScreen />,
		PaymentFormScreen: <PaymentFormScreen hidePriceAfterDisclaimer={coupon !== 'freetrial'} />,
	};

	return (
		<StripeElementsProvider isStripeNext>
			<Header isStatic hideMenu hideProfile />
			<GridWrapper columns={4} id={MAIN_CONTENT_ID} el="main">
				<Wrapper>{screenComponents[activeComponentName] || null}</Wrapper>
			</GridWrapper>
		</StripeElementsProvider>
	);
};

export default SubscribeScreens;
